import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
} from "@angular/core"
import { ModalService } from "../../services/modal.service"
import { ParentClass } from "../../parent"
import { UIContentType } from "@common-lib/types/general"
import { TableColumns } from "../reusable/table/table.component"
import { TracksService } from "@services/tracks.service"

@Component({
    selector: "app-mytracks",
    templateUrl: "mytracks.component.html",
    styleUrls: ["./mytracks.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MyTracksComponent extends ParentClass {
    public readonly tracksColumnsConfig: TableColumns = [
        {
            index: 1,
            name: "",
            size: "m", // 5fr
        },
        {
            index: 2,
            name: "Title",
            size: "xl", // 20fr
        },
        {
            index: 3,
            name: "Duration",
            size: "l",
        },
        {
            index: 4,
            name: "Creation Date",
            size: "l",
        },
        {
            index: 5,
            name: "",
            size: "s",
        },
        {
            index: 6,
            name: "",
            size: "s",
        },
    ]

    public content: Array<any>

    public readonly mobileColumnsConfig: TableColumns = [
        this.tracksColumnsConfig[0],
        this.tracksColumnsConfig[1],
        this.tracksColumnsConfig[4],
        this.tracksColumnsConfig[5],
    ]

    path = []

    title: UIContentType = "Compositions"
    trackView = "trackslist"
    playlist

    createRightClickMenu

    firstCompositionUpdate = true
    public animatedFolderID: string | undefined

    private folderAnimationTimeout: ReturnType<typeof setTimeout> | undefined

    constructor(
        protected modalService: ModalService,
        public tracksService: TracksService,
        private changeDetectorRef: ChangeDetectorRef
    ) {
        super()
    }

    public handlePlay(item: any): void {}

    public async createFolder(): Promise<void> {
        const folder = await this.tracksService.createFolder()

        if (folder === undefined) return

        if (this.folderAnimationTimeout !== undefined) {
            clearTimeout(this.folderAnimationTimeout)
        }

        this.animatedFolderID = folder._id
        this.changeDetectorRef.markForCheck()

        this.folderAnimationTimeout = setTimeout(() => {
            this.animatedFolderID = undefined
            this.folderAnimationTimeout = undefined
            this.changeDetectorRef.markForCheck()
        }, 500)
    }

    override ngOnDestroy(): void {
        if (this.folderAnimationTimeout !== undefined) {
            clearTimeout(this.folderAnimationTimeout)
        }

        super.ngOnDestroy()
    }
}
